import type { SmriqLastCompletedServiceInput } from '../services/smriq';
import type { SmriqLastCompletedServiceSelection } from '../types/smriq.types';
import { isAutoMatch } from './isAutoMatch';

export const toLastCompletedServiceInput = (
    selection: SmriqLastCompletedServiceSelection | null | undefined,
): SmriqLastCompletedServiceInput => {
    if (!selection) return { mode: 'none' };
    const details = {
        completed_date: selection.completed_date,
        completed_mileage: selection.completed_mileage,
    };
    return isAutoMatch(selection)
        ? { mode: 'auto', ...details }
        : { mode: 'selected', service_option_id: selection.service_option_id, ...details };
};
